import { render, staticRenderFns } from "./GestionAsignacionEquipoAuditorS1.vue?vue&type=template&id=0668a560&"
import script from "./GestionAsignacionEquipoAuditorS1.vue?vue&type=script&lang=js&"
export * from "./GestionAsignacionEquipoAuditorS1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports